/** 租户卡片 /metering/tenant/list（list.vue） */
export default {
  tenantListPage: {
    phTenantIdName: '租户名称/编号',
    phTenantStatus: '租户状态',
    phTenantType: '租户类型',
    phPayType: '付费模式',
    phLabels: '标签',
    tenantType0: '租户',
    tenantType1: '公区',
    tenantType2: '其他',
    tenantType3: '光伏',
    optStatusNormal: '正常',
    optStatusCancelled: '已注销',
    btnSearch: '查询',
    btnReset: '重置',
    btnExpand: '展开',
    btnCollapse: '收起',
    btnExport: '导出',
    exportCurrentPage: '导出本页',
    exportSelected: '导出选中',
    exportAll: '导出全部',
    exportSubAccounts: '导出子账号',
    expElectricAccount: '电费账户',
    expWaterAccount: '水费账户',
    subAccountsSheetName: '租户子账号',
    msgNoSubAccountsExport: '暂无有效子账号可导出',
    sectionTitle: '租户卡片',
    btnAdd: '新增',
    batchSettings: '批量设置',
    batchUrge: '催缴',
    batchArrearsTrip: '欠费跳闸',
    batchPayMode: '付费模式',
    batchWarnQuota: '预警额度',
    batchBillingPlan: '计费方案',
    batchDownloadCodes: '下载租户码',
    batchManualDebit: '批量扣款',
    selectAll: '全选',
    selectedCount: '已选 {n} 项',
    sortCreateTimeDesc: '创建时间(倒序)',
    sortCreateTimeAsc: '创建时间(正序)',
    sortMeterDesc: '电费专户(倒序)',
    sortMeterAsc: '电费专户(正序)',
    sortWaterDesc: '水费专户(倒序)',
    sortWaterAsc: '水费专户(正序)',
    sortNameAz: '名称(A-Z)',
    sortNameZa: '名称(Z-A)',
    viewTable: '表格',
    viewCard: '卡片',
    colTenantId: '租户ID',
    tipClickCopy: '点击可复制',
    colTenantName: '租户名称',
    avatarCharFallback: '租',
    colQrcode: '租户二维码',
    colLabels: '标签',
    colDedicatedMeters: '总设备',
    colDeviceTipMeter: '电表',
    colDeviceTipWater: '水表',
    colDeviceTipAir: '空调',
    colMeterBalanceYuan: '电费专户(元)',
    colWaterBalanceYuan: '水费专户(元)',
    colTenantStatus: '租户状态',
    colCreateTime: '创建时间',
    colPayType: '付费模式',
    optPayPrepaid: '预付费',
    optPayPostpaid: '后付费',
    colActions: '操作',
    btnDetail: '详情',
    btnManualDeduct: '手动扣款',
    btnUrge: '催缴',
    btnMore: '更多',
    btnEdit: '编辑',
    btnManualRecharge: '手动充值',
    emptyNoData: '暂无数据',
    cardAvatarFallback: '租户',
    cardDedicatedMeters: '总设备：',
    cardDeviceTipMeter: '电表',
    cardDeviceTipWater: '水表',
    cardDeviceTipAir: '空调',
    cardTenantBalance: '租户余额：',
    cardPayType: '付费模式：',
    cardMeterAccount: '电费专户：',
    cardWaterAccount: '水费专户：',
    cardTenantStatus: '租户状态：',
    cardCreatedAt: '创建时间：',
    balanceStatus_1: '正常',
    balanceStatus_2: '余额不足',
    balanceStatus_3: '欠费',
    balanceStatus_unknown: '未知',
    msgFetchTenantsFail: '获取租户数据失败',
    msgNothingToCopy: '无可复制内容',
    msgTenantIdCopied: '租户id已复制',
    msgCopyFail: '复制失败',
    msgNoDataExport: '暂无数据可导出',
    expColId: '租户ID',
    expColName: '租户名称',
    expColDevices: '总设备(台)',
    expColPayType: '付费模式',
    expColMeterBalance: '电费专户余额(元)',
    expColWaterBalance: '水费专户余额(元)',
    expColStatus: '租户状态',
    expColCreated: '创建时间',
    exportSheetName: '租户列表',
    exportFileNamePrefix: '租户列表_',
    msgExportSuccessN: '成功导出 {n} 条数据',
    msgExportFail: '导出失败',
    warnNoSelectedExport: '请先勾选要导出的租户',
    exporting: '正在导出...',
    successExportedLimit: '成功导出前 {count} 条（查询条件共 {total} 条，超出单次上限 2000 条）',
    msgNoAddPerm: '暂无新增权限',
    msgNoDeductPerm: '暂无扣款权限',
    msgSelectTenantsFirst: '请先勾选要下载的租户',
    msgGenQrcodeProgressN: '正在生成 {n} 个租户二维码...',
    qrcodeDownloadPrefix: '租户二维码-',
    unnamed: '未命名',
    msgDownloadNQrcodes: '成功下载 {n} 个租户二维码',
    msgDownloadFail: '下载失败',
    msgPageNoData: '当前页暂无数据',
    confirmExportAllQrcodeBody: '确定要导出当前页所有 {n} 个租户二维码吗？',
    titleTip: '提示',
    btnConfirm: '确定',
    btnCancel: '取消',
    msgExportNQrcodes: '成功导出 {n} 个租户二维码',
    msgExportQrcodeFail: '导出失败',
    msgQrcodeGenFail: '二维码生成失败',
    qrCanvasLabelTenantId: '租户ID:',
    qrCanvasLabelTenantName: '租户名:',
    qrCanvasScanHint: '请扫码绑定',
    msgNoViewPerm: '暂无查看权限',
    msgNoEditPerm: '暂无编辑权限',
    msgNoUrgePerm: '暂无催缴权限',
    confirmUrgeBody: '确定要向租户 {name} 发送催缴通知吗？',
    msgUrgeSuccess: '催缴通知发送成功',
    msgUrgeFail: '催缴失败',
    msgNoRechargePerm: '暂无充值权限',
    resourceTooltipTitle: '绑定资源（{n}）'
  },
  /** 租户列表页挂载的弹窗与二次确认（仅文案） */
  tenantDialogs: {
    qrcode: {
      title: '二维码',
      loading: '生成二维码中...',
      bindTipPrimary: '请租户扫描此二维码进行绑定',
      bindTipLink: '链接：',
      copyLink: '复制链接',
      download: '下载二维码',
      close: '关 闭',
      msgGenFail: '生成二维码失败，请重试',
      msgCopyOk: '链接已复制到剪贴板',
      msgCopyFail: '复制失败，请手动复制',
      msgDownloadOk: '二维码下载成功',
      msgDownloadFail: '下载失败，请重试',
      msgNotReady: '二维码尚未生成，请稍候'
    },
    recharge: {
      title: '手动充值',
      labelBizType: '充值类型',
      labelAmount: '充值金额',
      labelRemark: '备注内容',
      phAmount: '请输入充值金额',
      phRemark: '请输入备注内容',
      electric: '电费',
      water: '水费',
      cancel: '取 消',
      confirm: '确 定',
      submitting: '充值中...',
      ruleBizType: '请选择充值类型',
      ruleAmount: '请输入充值金额',
      ruleAmountMin: '充值金额不能小于0.01元',
      ruleRemark: '请输入备注内容',
      confirmTitle: '提示',
      confirmBody: '确认充值{type} ¥{amount} 吗？',
      msgSuccess: '充值成功',
      msgFail: '充值失败'
    },
    deduct: {
      title: '手动扣款',
      labelUseType: '扣款类型',
      labelBillDate: '账单日期',
      labelAmount: '扣款金额',
      labelRemark: '备注内容',
      phBillDate: '请选择账单日期',
      phAmount: '请输入扣款金额',
      phRemark: '请输入备注内容',
      electric: '电费',
      water: '水费',
      cancel: '取 消',
      confirm: '确 定',
      submitting: '扣款中...',
      ruleUseType: '请选择扣款类型',
      ruleBillDate: '请选择账单日期',
      ruleAmount: '请输入扣款金额',
      ruleAmountMin: '扣款金额不能小于0.01元',
      ruleRemark: '请输入备注内容',
      confirmTitle: '提示',
      confirmBody: '确认扣除 {type} {amount} 元？',
      msgSuccess: '扣款成功',
      msgFail: '扣款失败'
    },
    batchDebit: {
      title: '批量扣款',
      electric: '电费',
      water: '水费',
      labelUseType: '扣款类型',
      labelBillDate: '账单日期',
      labelRemark: '备注内容',
      labelDetail: '扣款明细',
      phBillDate: '请选择账单日期',
      phRemark: '请输入备注内容',
      uploadBtn: '点击上传',
      downloadTpl: '下载模板',
      tipFormat: '请上传 xlsx 格式',
      tipAmount: '注：仅支持「扣款金额」> 0 的操作',
      cancel: '取 消',
      confirm: '确 认',
      submitting: '提交中...',
      ruleUseType: '请选择扣款类型',
      ruleBillDate: '请选择账单日期',
      ruleRemark: '请输入备注内容',
      msgExceed: '最多上传 1 个文件',
      msgBadExt: '请上传 xlsx 或 xls 格式',
      msgParsed: '已解析 {n} 行',
      msgParseFail: '文件解析失败',
      msgNoManager: '缺少管理方信息',
      msgTenantListFail: '获取租户列表失败',
      msgTplOk: '模板已下载',
      msgTplFail: '下载模板失败',
      msgNoFile: '请上传明细',
      msgNoPositive: '明细中需至少一行扣款金额大于 0',
      confirmTitle: '提示',
      confirmBody: '确认提交批量扣款？',
      msgSubmitOk: '操作成功',
      sheetDetail: '明细',
      sheetFail: '失败信息',
      tplFileName: '明细模板.xlsx',
      failFileName: '失败信息.xlsx',
      colTenantId: '租户ID',
      colTenantName: '租户名',
      colAmount: '扣款金额',
      colError: '错误信息'
    },
    add: {
      titleCreate: '新增租户',
      titleEdit: '编辑租户',
      sectionBasic: '基本信息',
      sectionFee: '收费设置',
      sectionContact: '联系方式',
      labelName: '租户名称',
      phName: '请输入租户名称',
      phSelectName: '请选择租户名称',
      labelArea: '租占面积',
      phArea: '请输入租占面积',
      labelResources: '资源列表',
      phResources: '请选择资源',
      resourceBound: '已绑定',
      resourceBoundBy: '该资源已绑定租户：{name}',
      labelTenantType: '租户类型',
      labelPayType: '付费模式',
      labelPostPayComment: '后付费备注',
      phPostPayComment: '请填写后付费备注',
      payTypePrepaid: '预付费',
      payTypePostpaid: '后付费',
      tenantType0: '租户',
      tenantType1: '公区',
      tenantType2: '其他',
      tenantType3: '光伏',
      collectMeter: '收电费',
      collectWater: '收水费',
      yes: '是',
      no: '否',
      alarm1: '预警金额1',
      alarm2: '预警金额2',
      overdraw: '透支金额',
      yuan: '元',
      phAmount: '0.00',
      phoneLabel: '手机号{n}',
      phPhone: '请输入手机号',
      addPhone: '添加手机号',
      cancel: '取 消',
      confirm: '确 定',
      saving: '保存中...',
      ruleNameRequired: '请输入租户名称',
      ruleNameMax: '租户名称不能超过50个字符',
      ruleAreaRequired: '请输入租占面积',
      rulePhone: '请输入正确的手机号',
      ruleTenantTypeRequired: '请选择租户类型',
      rulePostPayCommentRequired: '请填写后付费备注',
      msgEditOk: '修改成功',
      msgCreateOk: '新增成功',
      msgRenterLoadFail: '明源客户列表加载失败',
      msgResourceLoadFail: '明源资源列表加载失败',
      msgFail: '操作失败'
    }
  }
}
